<template>
	<div class="start-screen">
		<div class="control-title">
			<div class="control-title-main">
				Интерактивный путеводитель
			</div>
      <div class="control-title-underline">
      </div>
		</div>

		<div class="control-area">
			<div class="title-right-col">

        <div class="start-text-content">
          <div>
            Пройдите короткий опрос и получите базовую
            дорожную карту по возможным шагам реализации
            Вашего инвестиционного проекта. Дорожную карту можно будет увидеть
            в личном кабинете* и сохранить в виде файла.
            При повторном прохождении опроса дорожная карта перезаписывается.
          </div>
          <div class="step-text control-title-text">
            *Если Вы хотите, чтобы результаты опроса сохранились в личном кабинете, авторизуйтесь перед тем, как пройти
            опрос.
          </div>
        </div>

				<div class="start-step-btn start-step-btn-hover" @click="$emit('onStart')">
					Получить дорожную карту
				</div>
			</div>
			<div class="step-col">
        <div class="svg-area">
          <img class="svg-area-img" src="/public/images/files/front/navigator_picture.svg" alt="start_icon">
        </div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ["is_result"],
	}
</script>

<style scoped>
	.start-screen {
		padding: 30px;
		color: #2E313D;
    border: 1px solid #E0E0E0;
    box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.15);
		/*background-color: #00A9D4;*/
	}

  .svg-area, .svg-area-img {
    width: auto;
    height: 100%;
  }

  .svg-area-img{
    margin-bottom: unset;
  }

  .start-text-content{
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }


	.control-title {
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
		/*padding: 3% ;*/
		/*text-align: center;*/
		margin-bottom: 2%;
	}

  .control-title-main{
    margin-bottom: 2%

  }
  .control-title-underline{
    height: 6px;
    background-color: #00A9D4;
  }

  .control-title-text{
    margin-top: 20px;
    color: #828282;
  }
  .title-right-col {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

	.control-title div {
		font-size: 22px;
	}

	.control-area {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.step-col {
		width: 28%;
		display: flex;
		flex-direction: column;
	}

	.step-text {
		font-size: 12px;
	}

  .start-step-btn {
    width: 50%;
    margin-top: 30px;
    margin-bottom: unset;
    text-align: center;
    padding: 12px;
    background-color: #DD262E;
    cursor: pointer;
    border-radius: 3px;
    font-weight: 300;
    font-size: 18px;
    letter-spacing: 0.15px;
    color: #FFFFFF;
  }

  .start-step-btn-hover:hover {
    background-color: #B31414;
  }

	.control-area-img img {
		max-width: 95%;
	}

	@media (max-width: 1282px) {
		.start-screen {
			padding: 15px;
		}

		.control-area {
			justify-content: center;
		}

    .start-step-btn {
      width: 100%;
    }
		.control-title div {
			font-size: 21px;
			width: 98%;
		}

		.step-col, .title-right-col {
			width: 45%;
			padding: 10px;
		}

	}

	@media (max-width: 1070px) {
    .start-step-btn {
      width: 100%;
    }

		.control-title div {
			font-size: 20px;
			width: 100%;
		}

		.step-col {
			width: 48%;
		}
	}

	@media (max-width: 600px) {
		.control-title div {
			font-size: 18px;
		}
    .start-step-btn {
      width: 100%;
    }
    .control-title-main {
      text-align: center;
    }

		.step-col, .title-right-col {
			width: 80%;
			padding: 10px;
		}

		.control-title div {
			font-size: 20px;
			width: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/StartScreen.vue